module.exports = __webpack_public_path__ + "static/media/cams_period.a642b1e1.png";